import {AuthenticationApi, CurrentUserApi} from '../services';
import * as actionTypes from './types';

const authApi = new AuthenticationApi();
const currentUserApi = new CurrentUserApi();

export function resetLoginForm() {
  return {type: actionTypes.RESET_LOGIN_FORM};
}

export function setLoginFormField(name, value) {
  return {
    type: actionTypes.SET_LOGIN_FORM_FIELD,
    payload: {name, value}
  };
}

export function logIn(model) {
  return {
    type: actionTypes.LOGIN,
    payload: authApi.logIn(model.toJS())
  };
}


export function setReturnPath(returnPath) {
  return {
    type: actionTypes.SET_RETURN_PATH,
    payload: returnPath
  };
}


export function loadIdentity() {
  return {
    type: actionTypes.LOAD_IDENTITY,
    payload: currentUserApi.identity()
  };
}


export function logOut() {
  return {
    type: actionTypes.LOGOUT,
    payload: authApi.logOut()
  };
}



// WEBPACK FOOTER //
// ./app/features/authentication/actions/creators.js